import { Pipe, PipeTransform } from '@angular/core';
import { ServerTimeService } from '../services/server-time.service';

@Pipe({
  name: 'timedif'
})
export class TimeDifPipe implements PipeTransform {
  constructor(private serverTimeService: ServerTimeService) {}

  async transform(date?: Date) {
    if (date) {
      const serverDateTime = await this.serverTimeService.getDateTimeNow();
      const diference = Date.parse(new Date(serverDateTime).toUTCString()) -
                          Date.parse(new Date(date).toUTCString());
      return this.millisToMinutes(diference);
    } else {
      return '';
    }
  }

   millisToMinutes(millis) {
    const minutes = Math.floor(millis / 60000);
    const seconds = Number(((millis % 60000) / 1000).toFixed(0));
    return minutes;
  }
}
